import SubscriptionViewModel from "../../factories/subscription-view-model";

/**
 * ViewModel for WorkItemRelationTabDialog
 */
class WorkItemRelationTabDialog extends SubscriptionViewModel {

    // #region Constructor

    /** 
     *Constructor
     */
    constructor($data:any, $dialog) {
        super($data.Parent.TagPage);
        $.extend(this, $data);
    }

    //  #endregion

    // #region Properties

    /** 
     * Id of the source work item
     */
    SourceWorkItemId: KnockoutObservable<string>;
    /**
    * Name of the source work item
    */
    SourceWorkItemTitle: KnockoutObservable<string>;
    /**
    * Id of the target work item
    */
    TargetWorkItemId: KnockoutObservable<string>;
    /**
    * Name of the target work item
    */
    TargetWorkItemTitle: KnockoutObservable<string>;
    /**
    * Id of the RelationType between work items
    */
    WorkItemRelationTypeId: KnockoutObservable<string>;
    /**
    * Name of the RelationType between work items
    */
    WorkItemRelationTypeName: KnockoutObservable<string>;

    // #endregion
}
export default WorkItemRelationTabDialog;